import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";

@Component({
  selector: "app-custom-foldable",
  templateUrl: "./custom-foldable.component.html",
  styleUrls: ["./custom-foldable.component.scss"],
})
export class CustomFoldableComponent implements OnInit, OnDestroy {
  @Input() changeable: boolean = false;
  @Input() deletable: boolean = false;
  @Input() title: string;
  @Input() isDisabled: boolean = false;
  @Input() isComponentOpen = new BehaviorSubject(false);
  @Output() isDisableOutput = new EventEmitter<boolean>();
  @Output() isComponentClosed = new EventEmitter<boolean>();

  private isComponentOpenSubscription: Subscription;
  private isModalOpen: boolean = false;
  constructor() {}

  ngOnInit() {
    this.isComponentOpenSubscription = this.isComponentOpen.subscribe(
      (value) => {
        this.isOpen = value;
      },
    );
  }

  get isChangeable() {
    return this.changeable;
  }

  get isDeletable() {
    return this.deletable;
  }

  set isOpen(val) {
    this.isDisableOutput.emit(val);
    this.isModalOpen = val;
    if (!val) {
      this.isComponentClosed.emit(!val);
    }
  }

  get isOpen() {
    return this.isModalOpen;
  }

  get isComponentDisabled() {
    return this.isDisabled && !this.isModalOpen ? true : false;
  }

  ngOnDestroy() {
    if (this.isComponentOpenSubscription) {
      this.isComponentOpenSubscription.unsubscribe();
    }
  }
}
